import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=80af81a6&scoped=true&"
import script from "./Select.vue?vue&type=script&lang=ts&"
export * from "./Select.vue?vue&type=script&lang=ts&"
import style0 from "./Select.vue?vue&type=style&index=0&id=80af81a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80af81a6",
  null
  
)

export default component.exports